import { Divider, Modal, Select } from "@mantine/core";

import { useGetOpenUserSettingModal, useSetOpenUserSettingModal } from "_common/hooks/global";
import { PrimaryButton, TextButton }                              from "_components/atoms/button";
import Icon                                                       from "_components/atoms/icon";
import ImageAtom                                                  from "_components/atoms/image";
import Typography                                                 from "_components/atoms/typography";
import LoadCropImage                                              from "_components/molecules/cropImage";
import ModalHeader                                                from "_components/molecules/modalHeader";
import UserOnboarding                                             from "_components/molecules/userOnboarding";
import useStyles                                                  from "_styles/organisms/editUserProfile";

const component = props => {
	const {
		// toggleEditUserProfile,
		userProfileDetails,
		handleInputChange,
		genderOptions,
		getSelectedOption,
		setGender,
		validInstagram,
		validDiscord,
		validYoutube,
		updateUserDetails,
		isLoading,
		handleGamesClick,
		handleLanguageClick,
		onboardModalStep,
		updateContentLocale,
		updateFollowingGames,
		gamesSelectedActive,
		languagesSelectedActive,
		onboard,
		hiddenFileInput,
		rawImageData,
		open,
		setOpen,
		handleImageUpload,
		uploadedProfileImage,
		onImageDrop
	} = props;

	const openUserSettings        = useGetOpenUserSettingModal ();
	const toggleUserSettingsPopup = useSetOpenUserSettingModal ();
	const { classes }             = useStyles ( { gamesSelectedActive, languagesSelectedActive, userProfileDetails } );
	const renderFollowingGames    = () => {
		if ( userProfileDetails?.followingGames?.length === 0 ) {
			return (
				<Typography
					title = { "Please select your favorite games" }
				/>
			);
		}

		return (
			<Typography
				size  = "sm"
				title = { userProfileDetails?.followingGames?.map ( ( game, idx ) => `${ game.name }${ idx === userProfileDetails?.followingGames.length - 1 ? "" : ", " }` ) }
			/>
		);

	};

	const renderContentLanguage = () => {

		if ( !( userProfileDetails?.contentLocale ) ) {
			return;
		}

		let language = userProfileDetails.contentLocale;

		if ( userProfileDetails?.contentLocale?.length === 2 ) {

			switch ( userProfileDetails.contentLocale ) {
				case "en": {
					language = "English";
					break;
				}

				case "ml": {
					language = "Malyalam";
					break;
				}

				case "hi": {
					language = "Hindi";
					break;
				}

				case "ta": {
					language = "Tamil";
					break;
				}

				case "te": {
					language = "Telugu";
					break;
				}

				case "kn": {
					language = "Kannada";
					break;
				}

				case "mr": {
					language = "Marathi";
					break;
				}

				case "bn": {
					language = "Bengali";
					break;
				}

				case "gu": {
					language = "Gujrati";
					break;
				}

				case "id": {
					language = "Bahasa Indonesia";
					break;
				}

				default:
					break;

			}
		}

		return (
			<Typography
				onClick = { handleLanguageClick }
				size    = "sm"
				title   = { language }
			/>
		);

	};

	const onInputClick = event => {
		event.target.value = "";
	};

	const triggerFileSelect = () => {
		hiddenFileInput.current.click ();
	};

	const toggleDialog = () => {
		setOpen ( !open );
	};

	return (
		<Modal
			classNames          = { { body: classes.modalBody, content: classes.modalContent } }
			closeOnClickOutside = { false }
			closeOnEscape       = { false }
			onClose             = { () => toggleUserSettingsPopup ( false ) }
			opened              = { !!openUserSettings }
			radius              = "lg"
			withCloseButton     = { false }
			zIndex              = { 1200 }
		>

			{
				onboard && (
					<UserOnboarding
						fromUserSettings     = { true }
						gamesSelected        = { userProfileDetails?.followingGames }
						onboardingStep       = { onboardModalStep }
						updateContentLocale  = { updateContentLocale }
						updateFollowingGames = { updateFollowingGames }
					/>
				)
			}

			<div className = { classes.topHeader }>
				<Typography
					className = { classes.settingsText }
					title     = "Settings"
				/>

				<Icon
					className = { classes.crossIcon }
					name      = "cross"
					onClick   = { () => toggleUserSettingsPopup ( false ) }

				/>

			</div>

			<div
				className = { classes.mainContent }
			>

				<div className = { classes.userAvatar }>
					<div className = { classes.avatarContainer }>
						<ImageAtom
							alt         = "Rooter Profile"
							className   = { classes.actorAvatar }
							src         = { uploadedProfileImage ? uploadedProfileImage : userProfileDetails.photo }
							useOriginal = { true }
						/>

					</div>

					<TextButton
						className = { classes.editPhoto }
						onClick   = { triggerFileSelect }
						radius    = "md"
						size      = "sm"
						title     = "Edit Photo"
						variant   = { "transparent" }
					/>

					<input ref = { hiddenFileInput }
						accept    = "image/*"
						onChange  = { e => onImageDrop ( e.target.files ) }
						onClick   = { onInputClick }
						style     = { { display: "none" } }
						type      = "file"
					/>

					<Modal
						centered
						classNames      = { { body: classes.modalBody } }
						maxWidth        = "md"
						onClose         = { toggleDialog }
						opened          = { open }
						radius          = "lg"
						withCloseButton = { false }
						zIndex          = { 1400 }
					>
						<ModalHeader onClose = { toggleDialog }
							title               = "Drag to Adjust"
						/>

						<div className = "positionRelative">
							<LoadCropImage fromUserSettings = { true }
								handleImageUpload              = { handleImageUpload }
								// onCropSuccess = { setImageDataBlob }
								onImageDrop                    = { triggerFileSelect }
								rawImageData                   = { rawImageData }
							/>

						</div>
					</Modal>
				</div>

				<div className = { classes.inputLabelandContentWrapper }>
					<Typography
						className = { classes.labelInput }
						title     = "Name"
					/>

					<input
						className   = { classes.inputContent }
						maxLength   = { 50 }
						onChange    = { e => handleInputChange ( e, "name" ) }
						placeholder = "Enter Your Name"
						value       = { userProfileDetails.name }
					/>
				</div>

				<div className = { classes.inputLabelandContentWrapper }>
					<Typography
						className = { classes.labelInput }
						title     = "Location"
					/>

					<input
						className   = { classes.inputContent }
						maxLength   = { 100 }
						onChange    = { e => handleInputChange ( e, "city" ) }
						placeholder = "Your Location"
						value       = { userProfileDetails.city }
					/>
				</div>

				<div className = { classes.inputLabelandContentWrapper }>
					<Typography
						className = { classes.labelInput }
						title     = "Bio"
					/>

					<textarea
						className   = { classes.textAreaInput }
						cols        = "60"
						onChange    = { e => handleInputChange ( e, "shortBio" ) }
						placeholder = "Let others know you a little better."
						rows        = "3"
						value       = { userProfileDetails.shortBio }
					/>
				</div>

				<div className = { classes.inputLabelandContentWrapper }>
					<Typography
						className = { classes.labelInput }
						title     = "Phone Number"
					/>

					<div className = { classes.mobileNumber }>

						<Icon sameInBothTheme
							className = { classes.verifiedMobileTick }
							name      = "verifiedMobileTick"
						/>

						<div>
							{userProfileDetails.mobile}
						</div>
					</div>
				</div>

				<div className = { classes.inputLabelandContentWrapper }>
					<Typography
						className = { classes.labelInput }
						title     = "Gender"
					/>

					<div className = { classes.genderDropdown }>
						<Select
							data        = { genderOptions }
							onChange    = { setGender }
							placeholder = "Select your gender"
							styles      = { theme => {
								return {
									input: {
										background   : theme.other.colors.input.primary,
										border       : "1rem",
										borderRadius : "1rem",
										fontSize     : "1.4rem",
										padding      : "2rem 1rem"
									},
									dropdown: {
										borderRadius : "0.5rem",
										background   : theme.other.colors.dialog.primary
									},
									item: {
										borderRadius       : "0.5rem",
										margin             : "0",
										"&[data-selected]" : {
											background: theme.other.paletteNew.primaryDarkBlue
										}
									}
								};
							} }
							value       = { getSelectedOption ( userProfileDetails.gender )?.value }
						/>
					</div>

				</div>

				<div className = { classes.seperator } />

				<div className = { classes.inputLabelandContentWrapper }>
					<div className = { `${ classes.iconLabel } ` }>

						<Icon sameInBothTheme
							className = { classes.handleIcon }
							name      = "instagram"
						/>

						<Typography
							className = { "label" }
							title     = "Instagram"
						/>
					</div>

					<div className = { classes.inputWrapper }>
						<input
							className   = { `${ classes.inputContent } ${ !validInstagram ? " error" : "" }` }
							onChange    = { e => handleInputChange ( e, "instagram" ) }
							placeholder = "Instagram Profile URL"
							value       = { userProfileDetails.instagram }
						/>

						{
							!validInstagram &&
							<div className = { classes.errorUrl }>Enter Valid Instagram Url</div>
						}
					</div>

				</div>

				<div className = { classes.inputLabelandContentWrapper }>
					<div className = { `${ classes.iconLabel } ` }>

						<Icon sameInBothTheme
							className = { classes.handleIcon }
							name      = "youtube"
						/>

						<Typography
							className = { "label" }
							title     = "Youtube"
						/>
					</div>

					<div className = { classes.inputWrapper }>
						<input
							className   = { `${ classes.inputContent } ${ !validYoutube ? " error" : "" }` }
							onChange    = { e => handleInputChange ( e, "youtube" ) }
							placeholder = "Youtube Channel URL"
							value       = { userProfileDetails.youtube }
						/>

						{
							!validYoutube &&
							<div className = { classes.errorUrl }>Enter Valid Youtube Channel Url</div>
						}
					</div>
				</div>

				<div className = { classes.inputLabelandContentWrapper }>
					<div className = { `${ classes.iconLabel } ` }>

						<Icon sameInBothTheme
							className = { classes.handleIcon }
							name      = "discord"
						/>

						<Typography
							className = { "label" }
							title     = "Discord"
						/>
					</div>

					<div className = { classes.inputWrapper }>
						<input
							className   = { `${ classes.inputContent } ${ !validDiscord ? " error" : "" }` }
							onChange    = { e => handleInputChange ( e, "discord" ) }
							placeholder = "Discord Server URL"
							value       = { userProfileDetails.discord }
						/>

						{
							!validDiscord &&
							<div className = { classes.errorUrl }>Enter Valid Discord Server URL</div>
						}
					</div>
				</div>

				<Typography
					className = { classes.labelInputTag }
					title     = "Content Settings"
				/>

				<div className = { classes.inputContainer }>
					<Typography
						className = { classes.labelInputTagSubHeading }
						title     = "Favorite Games"
					/>

					<div className = { classes.inputWrapper }>

						<div className = { classes.followingGamesContainer }
							onClick       = { handleGamesClick }
						>
							<div>
								{renderFollowingGames ()}
							</div>

							<Icon
								className = { classes.downArrowIcon }
								name      = "arrowDown"
							/>

						</div>
					</div>
				</div>

				<div className = { classes.inputContainer }>
					<Typography
						className = { classes.labelInputTagSubHeading }
						title     = "Content Language"
					/>

					<div className = { classes.inputWrapper }>

						<div className = { classes.contentlocaleContainer }
							onClick       = { handleLanguageClick }
						>
							{" "}

							<div>
								{renderContentLanguage ()}
							</div>

							<Icon
								className = { classes.downArrowIcon }
								name      = "arrowDown"
							/>

							{" "}

						</div>
					</div>

				</div>

			</div>

			<Divider />

			<div className = { classes.saveButtonContainer }>
				<PrimaryButton
					disabled = { isLoading }
					loading  = { isLoading }
					onClick  = { updateUserDetails }
					title    = "Save Changes"
				/>
			</div>
		</Modal>
	);
};

export default component;
